class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();

this.addEventListener('click', (event) => {
  const isPeeking = document.body.classList.contains('cart-drawer-peek');
  const isOpen = this.classList.contains('active');
  const clickedClose = event.target.closest('.drawer__close');
  const clickedPeekLink = event.target.closest('.drawer__peek-link');

  if (clickedClose || clickedPeekLink) return;

  if (isPeeking && !isOpen) {
    event.preventDefault();
    this.open();
  }
});

    document.addEventListener('click', (event) => {
      const clickedInsideDrawer = this.contains(event.target);
      const clickedCartIcon = event.target.closest('#cart-icon-bubble');

      if (
        this.classList.contains('active') &&
        !clickedInsideDrawer &&
        !clickedCartIcon
      ) {
        this.close();
      }
    });

    this.syncCartDrawerState();

    const cartObserver = new MutationObserver(() => {
      this.syncCartDrawerState();
    });

    cartObserver.observe(this, {
      childList: true,
      subtree: true,
    });
  }

  isIndexPage() {
    return document.body.classList.contains('template-index');
  }

  isCartEmpty() {
    const cartItems = this.querySelectorAll('.cart-item');
    const drawerItems = this.querySelector('cart-drawer-items');

    return (
      drawerItems?.classList.contains('is-empty') ||
      cartItems.length === 0
    );
  }

  shouldShowPeek() {
    return !this.isIndexPage() || !this.isCartEmpty();
  }

  syncCartDrawerState() {
    const isEmpty = this.isCartEmpty();

    if (isEmpty) {
      this.classList.add('is-empty');
      this.classList.remove('active');
      document.body.classList.remove('cart-drawer-open');
    } else {
      this.classList.remove('is-empty');
    }

    if (this.shouldShowPeek()) {
      this.classList.remove('is-empty');
      document.body.classList.add('cart-drawer-peek');
    } else {
      this.classList.add('is-empty');
      document.body.classList.remove('cart-drawer-peek');
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');

      document.body.classList.add('cart-drawer-open');
      document.body.classList.remove('cart-drawer-peek');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');

    document.body.classList.remove('cart-drawer-open');

    if (this.shouldShowPeek()) {
      this.classList.remove('is-empty');
      document.body.classList.add('cart-drawer-peek');
    } else {
      this.classList.add('is-empty');
      document.body.classList.remove('cart-drawer-peek');
    }

    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.classList.remove('is-empty');

    document.body.classList.remove('cart-drawer-peek');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');

      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }

      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);